<div class="layout-wrapper" [ngClass]="{'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple,
		'layout-static': isStatic(),
		'layout-overlay': isOverlay(),
		'layout-horizontal': isHorizontal(),
		'layout-rtl': app.isRTL,
		}" [class]="'layout-menu-'+ app.menuTheme+ ' layout-topbar-'+ app.topbarTheme">

	<div class="layout-main p-0 ml-0">
		<app-slim-topbar></app-slim-topbar>

		<div class="layout-content p-0" [ngClass]="layoutMarginResponsive()">
			<div class="grid mt-3">
				<div class="col-12 text-center">
					<h3 class="p-0">{{ 'UNSUBSCRIBE_MAIL_NOTIFICATION_TITLE' | translate }}</h3>
				</div>
				<div class="col-12">
					<div class="card">
						<div *ngIf="!deleteEmailEventsNotificationsSuccess && !deleteEmailEventsNotificationsFailed">
							<div class="col-12 flex justify-content-center">
								<p-checkbox [binary]="true"
									label="{{'UNSUBSCRIBE_MAIL_NOTIFICATION_NOTE' | translate }}" (onChange)="setConfirmCheckbox($event)">
								</p-checkbox>
							</div>
							<div class="col-12 flex justify-content-center mt-3">
								<button type="button" pButton pRipple (click)="unsubscribeMail()"
									label="{{ 'CONFIRM' | translate }}" [disabled]="!this.checkboxValue"
									class="p-button-danger text-xl font-normal mb-2 mx-1"
									[ngClass]="dynamicButtonWidth()">
								</button>
							</div>
						</div>
						<div *ngIf="deleteEmailEventsNotificationsSuccess">
							<div class="col-12 flex flex-column align-items-center justify-content-center bg-green-200 p-1 border-round-xl">
								<p-tag icon="pi cm-check" [value]="('UPDATE_NOTIFICATION_SETTINGS_SUCCESS' | translate)" severity="success"></p-tag>
							</div>
						</div>
						<div *ngIf="deleteEmailEventsNotificationsFailed">
							<div class="col-12 flex flex-column align-items-center justify-content-center bg-red-200 p-1 border-round-xl">
								<p-tag icon="pi cm-cancel" [value]="('GENERIC_ERROR_FORMAL' | translate)" severity="danger"></p-tag>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<app-common-footer></app-common-footer>
	</div>

</div>

